'use strict';
module.exports = function scrollWhenDragging(viewportDOM, scrollPredicate) {
	let dragOrigin;
	const img = new Image(),
		stageDom = viewportDOM && viewportDOM.querySelector('[data-mapjs-role~="stage"]');
	if (!stageDom) {
		throw new Error('invalid-args');
	}
	img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=';
	stageDom.setAttribute('draggable', 'true');
	viewportDOM.addEventListener('dragstart', (e) => {
		if (e.target !== stageDom) {
			e.stopPropagation();
			return;
		}
		if (scrollPredicate()) {
			e.dataTransfer.setDragImage(img, 0, 0);
			dragOrigin = {
				top: viewportDOM.scrollTop,
				left: viewportDOM.scrollLeft,
				clientX: e.clientX,
				clientY: e.clientY
			};
		} else {
			e.preventDefault();
			e.stopPropagation();
		}
	});
	viewportDOM.addEventListener('dragover', (e) => {
		if (dragOrigin) {
			viewportDOM.scrollTop = dragOrigin.top + dragOrigin.clientY - e.clientY;
			viewportDOM.scrollLeft = dragOrigin.left + dragOrigin.clientX - e.clientX;
		}
	});
	viewportDOM.addEventListener('dragend', () => {
		dragOrigin = undefined;
	});
};
